import { render } from "./GridSubKelompokAccount.vue?vue&type=template&id=4d9709b6"
import script from "./GridSubKelompokAccount.vue?vue&type=script&lang=js"
export * from "./GridSubKelompokAccount.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__